var map = {
	"./background.scss": "./src/vab/styles/themes/background.scss",
	"./blue-black.scss": "./src/vab/styles/themes/blue-black.scss",
	"./blue-white.scss": "./src/vab/styles/themes/blue-white.scss",
	"./green-black.scss": "./src/vab/styles/themes/green-black.scss",
	"./green-white.scss": "./src/vab/styles/themes/green-white.scss",
	"./ocean.scss": "./src/vab/styles/themes/ocean.scss"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/vab/styles/themes sync \\.scss$";